
export default {
  name: 'NotFound',
  layout: 'error',
  nuxtI18n: {
    paths: {
      en: '/not-found',
      it: '/not-found',
      de: '/not-found'
    },
  },
  head() {
    return {
      title: `Not Found - Vitesy`
    }
  }
}
